import { render, staticRenderFns } from "./OrderItemsTable.vue?vue&type=template&id=69b637c8&scoped=true&"
import script from "./OrderItemsTable.vue?vue&type=script&lang=js&"
export * from "./OrderItemsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b637c8",
  null
  
)

export default component.exports